export enum DeviceType {
  LEGIONELLA = 'legionella',
  COLD_STORAGE = 'coldStorage',
  FEEDBACK_PANEL = 'feedbackPanel',
  CLEANING_VALIDATION = 'cleaningValidation',
  DOOR = 'door',
  WATER = 'water',
  MOTION = 'motion',
  CC = 'cc',
  WATER_METER = 'waterMeter',
  GAS_METER = 'gasMeter',
  ELECTRICITY_METER = 'electricityMeter',
  PHOTOVOLTAIC_METER = 'photovoltaicMeter',
  THERMAL_METER = 'thermalMeter',
  FUEL_METER = 'fuelMeter',
  // Volume et énergie cumulés du compteur de chaleur d'un circuit (`distributionHeating_volume` / `_energy`) :
  // des compteurs comme les autres pour la branche index + consommation de l'ingestion, qui nomme ses séries
  // d'après ce type (`volume` / `volumeConsumption`, `energy` / `energyConsumption`). Le volume n'est pas une
  // consommation d'eau (l'eau d'un circuit tourne en boucle) ; l'énergie à facturer reste un thermalMeter.
  VOLUME_METER = 'volume',
  ENERGY_METER = 'energy',
  TEMPERATURE = 'temperature',
  BATTERY = 'battery',
  PUMP = 'pump',
  COM = 'com',
  MANUAL = 'manual',
  HUMIDITY = 'humidity',
  CO2 = 'co2',
  TVOC = 'tvoc',
  DEFAULT = 'default',
  CHLORINE = 'chlorine',
  PH = 'ph',
}
